@if (field.hasErrors()) {
  <c-validation-error
    class="field-message field-message--invalid"
    [validationMessages]="field.errors()"
    [controlValue]="field.value()" />
} @else if (helpText()) {
  <p class="field-message">{{ helpText() }}</p>
}
